import { createSelector } from 'reselect';

const selectLayout = (state) => state.layout;

const makeSelectIsShowFilterOnHeader = () =>
  createSelector(selectLayout, (subState) => subState.isShowFilterOnHeader);

export { selectLayout, makeSelectIsShowFilterOnHeader };
